import { View } from 'react-native'
import CheckboxGroupItem, {
  GroupItemImage,
  OrderCheckboxItemProps,
} from './CheckboxGroupItem'
import { isValidElement, Dispatch, SetStateAction, useCallback } from 'react'
import React from 'react'
import cn from '@ui/utils/cn'

export type CheckboxGroupProps = {
  mode?: 'checkbox' | 'radio'
  active: string[]
  setActive: Dispatch<SetStateAction<string[]>>
  children?: React.ReactNode
  defaultActive?: string[]
  error?: boolean
}

const CheckboxGroup = ({
  active,
  setActive,
  mode = 'checkbox',
  children,
  defaultActive = [],
  error,
}: CheckboxGroupProps) => {
  const toggleActive = useCallback(
    (id: string) => {
      if (mode === 'radio') {
        setActive([id])
        return
      }

      setActive((prev) =>
        prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
      )
    },
    [mode, setActive]
  )

  const count = React.Children.count(children)

  return (
    <View
      className={cn(
        'w-full items-center justify-center overflow-hidden rounded-xl border border-black/10',
        error && 'border-red-600'
      )}
    >
      {React.Children.map(children, (child, index) => {
        if (isValidElement<OrderCheckboxItemProps>(child)) {
          return React.cloneElement(child, {
            last: index === count - 1,
            onPress: !child.props.onPress
              ? toggleActive
              : (id) => {
                  child.props.onPress(id)
                  toggleActive(id)
                },
            active: active.length > 0 ? active : defaultActive,
            mode,
            error,
          })
        }
        return child
      })}
    </View>
  )
}

export default CheckboxGroup

CheckboxGroup.Item = CheckboxGroupItem
CheckboxGroup.ItemImage = GroupItemImage
